<template>
    <div :class="['cms_fullwidth_lane', stylename]" :cms_menuname="menuname" v-show="MenuHtml!=''">
        <GrcDB ref="GRCDB"></GrcDB>
        <div class="cms_topmenu_fullwidth">
            <div class="cms_topmenu_logo" v-html="logo_html">
            </div>
            <div class="cms_topmenu_right" v-html="center_html">
            </div>
            <div class="cms_topmenu_bars">
                <div class="topmenu_headertext" @click="ShowHideMenu">
                    <i class="fas fa-bars" v-show="IsMenuVisible==false"></i>
                    <i class="fas fa-times" v-show="IsMenuVisible"></i>
                </div>

                <div class="topmenu_subcont" v-show="IsMenuVisible" v-html="MenuHtml">

                </div>
                           
            </div>

        </div>

    </div>
</template>


<script>

import GrcDB from './GrcDB.vue'

export default {
  name: 'grccms_topmenu',
  components: {
    GrcDB,
  },
  props: {
    cms_menuname: String,
    cms_stylename: String
  },

  data () {
        return {
            menuname: this.cms_menuname,
            stylename: this.cms_stylename,
            MenuHtml: "",
            logo_html:"",
            center_html:"",
            IsMenuVisible:false,
        }
  },
  model: {

  },  
  methods:{

    ShowHideMenu()
    {
        this.IsMenuVisible = !(this.IsMenuVisible);
    },


    async Init()
    {
        var QP = {
            sSessionID: "[APPSESSIONID]",
            sAlias: GRCAPP_GetParameters.ALIAS,
            sMenuName: this.menuname,
        };
        var Q;
        await this.$refs.GRCDB.GetData("CMS_GetTopMenu", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            console.log(Q);
            return;
        }

        let s = Q.DATA[0].LogoHtml.replace(/>\s+</g,'><');
        this.logo_html = s;

        s = Q.DATA[0].CenterHtml.replace(/>\s+</g,'><');
        this.center_html = s;

        s = Q.DATA[0].MenuHtml.replace(/>\s+</g,'><');
        this.MenuHtml = s;

    },

  },
  created()
  {
    if (typeof this.menuname == "undefined")
    {
      this.menuname = "";
    }

    if (typeof this.stylename == "undefined")
    {
      this.stylename = "";
    }

    if (this.menuname == "") { return; }
    
  },

 mounted()
 {
    this.Init();
 },


}


</script>


<style scoped>


</style>
